<template>
    <div :class="$attrs.class">
        <div class="row mt-5">
            <div class="col-12 col-sm-3 my-3 my-sm-0">
                <p class="text-md text-white m-0 pointer" data-bs-toggle="modal" data-bs-target="#exampleModal">
                    <img class="ms-2" src="/front/assets/images/wrist.svg" alt="" title="">
                    دور مچ
                    <img class="me-2 info" src="/front/assets/images/info.svg" alt="" title="">
                </p>
            </div>
            <div class="col-4 col-sm-3 my-3 my-sm-0 wrist">
                <input
                    type="radio"
                    name="wrist"
                    value="1"
                    v-model="internalValue"
                    id="small"
                >
                <label class="me-2 men" for="small">کوچک</label>
            </div>
            <div class="col-4 col-sm-3 my-3 my-sm-0 wrist">
                <input
                    type="radio"
                    name="wrist"
                    value="2"
                    v-model="internalValue"
                    id="mid"
                >
                <label class="me-2 man" for="mid">متوسط</label>
            </div>
            <div class="col-4 col-sm-3 my-3 my-sm-0 wrist">
                <input
                    type="radio"
                    name="wrist"
                    value="3"
                    v-model="internalValue"
                    id="large"
                >
                <label class="me-2 man" for="large">بزرگ</label>
            </div>
            <div v-if="error" class="form-error">
                <p class="m-0 text-sm text-error mb-3">{{ error }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import { v4 as uuid } from 'uuid'

export default {
    inheritAttrs: false,
    props: {
        id: {
            type: String,
            default() {
                return `text-input-${uuid()}`
            },
        },
        error: String,
        modelValue: Number,
    },
    emits: ['update:modelValue'],
    computed: {
        internalValue: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            }
        }
    }
}
</script>
